<template>
    <div id="removeclass">
      <modal
        :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal"
      >
        <template slot="body">
          <app-overlay-loader v-if="preloader" />
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : addurl">
            <div class="form-group row align-items-center">
              <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
                <label for="inputs_name" >
                  {{ $t("name") }}
                </label>
                <app-input
                  id="inputs_name"
                  type="text"
                  placeholder="Enter Name"
                  v-model="inputs.name"
                  :required="true"
                />
              </div>
            </div>
            <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
                    <label for="inputs_email">
                        {{ $t("description") }}
                    </label>
                    <app-input
                        id="inputs_email"
                        type="textarea"
                        v-model="inputs.description"
                        :required="false"
                    />
                </div>
            </div>
          </form>
        </template>
      </modal>
    </div>
  </template>
  
  <script>
  import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
  import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
  import { axiosPost, axiosGet } from "../../../../Helpers/AxiosHelper";
  import { RESPONSE_CATEGORY_STORE} from "../../../../Config/ApiUrl";
  import AppLibrary from "../../../../Helpers/AppLibrary";
  
  export default {
    name: "AddModal",
    extends: AppLibrary,
    mixins: [FormMixin, ModalMixin],
    props: {
      tableId: String,
    },
    data() {
      return {
        addurl:RESPONSE_CATEGORY_STORE,
        preloader: false,
        inputs: {},
        modalId: "demo-add-response-category-modal",
        modalTitle: this.$t("add"),
      }
    },
    created() {
    },
    methods: {
      submit() {
        let formData = new FormData();
          Object.keys(this.inputs).forEach((key) => {
            formData.append(key,this.inputs[key]);
          });

        this.save(formData);
      },
      afterSuccess(response) {
        this.$toastr.s(response.data.message);
        this.$hub.$emit("reload-" + this.tableId);
      },
    },
    mounted() {
      $(function () {
        $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
      });
    },
  };
  </script>
  